import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Grid } from '@material-ui/core';
import UserList from './userList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          { children }
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function TabbedTable(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { employeeColumns, employeeRows, checkerRows, employeeCount, getTrafficHistory } = props;
  const [employeeOffset, setEmployeeOffset ] = useState(0);
  const [ employeeSize, setEmployeeSize ] = useState(20);
  const [ employeePage, setEmployeePage] = useState(0);
  // const [ eRows, setERows ] = useState(employeeRows);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function handleChangeEmployeePage(newPage) {
    var params = {};
    if(employeePage < newPage) {
        setEmployeeOffset(employeeSize + employeeOffset);
        params = { 
            page_size: employeeSize,
            page_offset: employeeOffset + employeeSize
        }
        getTrafficHistory(null, null, params);
    } else {
        setEmployeeOffset(employeeOffset - employeeSize);
        params = { 
            page_size: employeeSize,
            page_offset: employeeOffset - employeeSize
        }
        getTrafficHistory(null, null, params);
        console.log(params);
    }
    setEmployeePage(newPage);
};

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Workers" {...a11yProps(0)} />
          <Tab label="Representatives" {...a11yProps(1)} />
          <Tab label="Health Checkers" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
          <Grid container justify="center" alignItems="center">
            <UserList columns={employeeColumns || []} rows={employeeRows || []} count={employeeCount} handlePage={handleChangeEmployeePage}/>
          </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
          <Grid container justify="center" alignItems="center">
            <UserList columns={employeeColumns || []} rows={checkerRows || []} />
          </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
          <Grid container justify="center" alignItems="center">
            <UserList columns={employeeColumns || []} rows={[]} />
          </Grid>
      </TabPanel>
    </div>
  );
}